import { InsuredSupportContract } from "./Contracts/InsuredSupportContract";
import { PolicyContract } from "./Contracts/PolicyContract";
import { SupportRequestContract } from "./Contracts/SupportRequestContract";

declare global
{
	interface Window
	{
		NauUtility: any;
		exitOkay: any;
	}
}

export class Support
{
	private static readonly RequestSupport_GetSupportDetails = "/webapi/Support/GetSupportDetails/";
	private static readonly RequestSupport_SubmitRequest = "/webapi/Support/SubmitRequest/";

	/**
	 * Used for taking a specific exam by a entity
	 * @param options options required to take exam
	 */
	constructor()
	{
	}

	/** Initialize the exam question to be taken on load */
	public InitializeSupportRequest()
	{
		$('#resetButton').click(() => {
			$("#supportRequest").show();
			$("#submissionSuccess").hide();
			$("#submissionFailed").hide();
		});

		$("#loadingSpinnerContainer").show();

		this.LoadSupportRequestInfo((supportRequestInfo) =>
		{
			$("#loadingSpinnerContainer").hide();

			this.BuildSupportRequestForm(supportRequestInfo, this.SubmitForm);
		});
	}

	private BuildSupportRequestForm(supportRequestInfo: InsuredSupportContract, saveCallback: Function)
	{
		const validationGroupName = "supportRequestValidationGroup";
		
		let formData = new SupportRequestContract()

		formData.webBrowser = window.navigator.userAgent; /*browser type*/
		formData.phoneNumber = supportRequestInfo.userPhone;
		formData.emailAddress = supportRequestInfo.userEmailAddress;
		formData.name = supportRequestInfo.name;
		formData.userName = supportRequestInfo.userName;

		if (supportRequestInfo.usersAgents != null && supportRequestInfo.usersAgents.length > 0)
		{
			formData.agentId = supportRequestInfo.usersAgents[0].agentId;
		}

		let formContainer = $('#supportRequest').dxForm({
			colCount: 1,
			showRequiredMark: false,
			formData: formData,
			validationGroup: validationGroupName,
			items: [{
				name: 'requestSupport',
				itemType: 'group',
				items: [
					{
						template: "<span>Choose one of the categories to request information or ask a question</span>",
					},
					{
						//Support Category
						label: {
							location: "top",
							text: 'Category',
						},
						dataField: "supportCategoryDomainId",
						validationRules: [{
							type: 'required',
							message: 'Category is required'
						}],
						editorType: 'dxSelectBox',
						helpText: '',
						editorOptions: {
							items: supportRequestInfo.supportCategories,
							placeholder: 'Select a topic',
							displayExpr: "categoryName",
							valueExpr: "supportCategoryDomainId",
							onValueChanged: (e) =>
							{
								const selectedCategory = e.component.option('selectedItem');
								formContainer.dxForm('instance').itemOption("requestSupport.supportCategoryDomainId", "helpText", selectedCategory.note == undefined ? '' : selectedCategory.note);
								$('#selectedCategoryName').text(selectedCategory.categoryName);
								var selectedPolicyType = formContainer.dxForm("instance").getEditor("policyTypeSelect")?.option('value');
								var filteredPolicies = supportRequestInfo.usersPolicies?.filter((item: PolicyContract) => item.policyMajorLine == selectedPolicyType);
								formContainer.dxForm("instance").getEditor("policySelect")!.option("items", filteredPolicies);
							}
						}
					},
					{
						//Name
						label: {
							location: "top",
							text: 'Name'
						},
						dataField: 'name'
					},
					{
						//User name
						label: {
							location: "top",
							text: 'User name'
						},
						dataField: 'userName'
					},
					{
						//Comments/Question
						label: {
							location: "top",
							text: 'Question'
						},
						dataField: 'comments',
						editorType: 'dxTextArea',
						editorOptions: {
							height: 140
						},
						validationRules: [{
							type: 'required',
							message: 'Notes are required'
						}]
					},
					{
						//Policy Type (Logged in, policy category chosen)
						name: "policyTypeSelect",
						label: {
							location: "top",
							text: 'Policy Type'
						},
						editorType: 'dxSelectBox',
						editorOptions: {
							items: supportRequestInfo.majorLinesAvailable,
							placeholder: 'Select a Policy Type',
							onValueChanged: (e) =>
							{
								var filteredPolicies = supportRequestInfo.usersPolicies?.filter((item: PolicyContract) => item.policyMajorLine == e.value);
								formContainer.dxForm("instance").getEditor("policySelect")!.option("items", filteredPolicies);
							},
							showClearButton: true
						}
					},
					{
						//Policy (Logged in, policy category chosen)
						name: "policySelect",
						label: {
							location: "top",
							text: 'Policy Number'
						},
						dataField: "policyDisplayNumber",
						editorType: 'dxSelectBox',
						editorOptions: {
							items: supportRequestInfo.usersPolicies,
							placeholder: 'Select a Policy Number',
							displayExpr: "policyDisplay",
							valueExpr: "policyDisplayNumber",
							searchEnabled: true,
							searchExpr: "policyDisplay",
							showClearButton: true
						},
					},
					{
						//Agent
						label: {
							location: "top",
							text: 'Agent'
						},
						dataField: "agentId",
						editorType: 'dxSelectBox',
						editorOptions: {
							items: supportRequestInfo.usersAgents,
							placeholder: 'Select Agent',
							displayExpr: "displayName",
							valueExpr: "agentId"
						}
					},
					{
						//Preferred contact method
						label: {
							location: "top",
							text: 'Preferred Method of Contact'
						},
						dataField: "contactMethodDomainId",
						editorType: 'dxSelectBox',
						editorOptions: {
							items: supportRequestInfo.preferredContactCollection,
							placeholder: 'Select a Contact Method',
							displayExpr: "displayValue",
							valueExpr: "id",
							onValueChanged: (e) =>
							{
								const selectedContactMethod = e.component.option('selectedItem');
								$('#preferredContactMethod').text(selectedContactMethod.displayValue);
							}
						}
					},
					{
						//Email address
						label: {
							location: "top",
							text: 'Email Address'
						},
						dataField: 'emailAddress',
						editorType: 'dxTextBox',
						validationRules: [{
							type: 'email',
							message: 'Email is invalid'
						}]
					},
					{
						//Phone number
						label: {
							location: "top",
							text: 'Phone'
						},
						dataField: 'phoneNumber',
						editorType: 'dxTextBox',
						editorOptions: {
							mask: '(X00)000-0000',
							maskRules: {
								'X': /[02-9]/
							},
							maskInvalidMessage: 'The phone must have a correct USA phone format.'
						},
						validationRules: [{
							type: 'required',
							message: 'Phone number is required',
						}]
					},
					{
						//Buttons
						colCount: 5,
						itemType: 'group',
						items: [{
							itemType: 'empty',
							colSpan: 3
						},
						{
							//Reset button
							itemType: 'button',
							buttonOptions: {
								text: 'Reset',
								onClick: (e) =>
								{
									this.InitializeSupportRequest();
								}
							}
						},
						{
							//Submit button
							name: "submitButton",
							itemType: 'button',
							buttonOptions: {
								validationGroup: validationGroupName,
								useSubmitBehavior: true,
								text: 'Submit',
								onClick: () =>
								{
									let result = formContainer.dxForm('instance').validate();

									if (result.isValid)
									{
										saveCallback(formData);
									}
								}
							}
						}]
					}					
					]
			}
			]

		});
	}

	private SubmitForm(data: SupportRequestContract)
	{
		$('#question').text(data.comments == undefined ? "" : data.comments.toString());
		$('#submissionDate').text(new Date().toLocaleString());

		window.NauUtility.apiOps.postAsync({
			apiVersion: '1.0',
			api: Support.RequestSupport_SubmitRequest,
			data: JSON.stringify(data),
			success: (result) => {

				if (window.NauUtility.serverValidationOps.hasErrors({ response: result }))
				{
					$("#supportRequestErrorSummary").empty();
					window.NauUtility.serverValidationOps.applyErrorsToForm({
						errorResponse: result.responseState,
						$miscErrorControl: $("#supportRequestErrorSummary") 
					});
					$("#supportRequestErrorSummary").show();
				}
				else
				{
					$("#supportRequest").hide();
					$("#submissionSuccess").show();
					$("#supportRequestErrorSummary").hide();
				}
			},
			error: () =>
			{
				$("#supportRequest").hide();
				$("#submissionSuccess").hide();
				$("#submissionFailed").show();
				$("#supportRequestErrorSummary").show();
			}
		});
	}

	private LoadSupportRequestInfo(onSuccess: Function)
	{
		window.NauUtility.apiOps.getAsync({
			apiVersion: '1.0',
			api: Support.RequestSupport_GetSupportDetails,
			success: onSuccess
		});
	}
}